var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-bar" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _c(
          "v-btn",
          {
            staticClass: "mr-4",
            attrs: { icon: "" },
            on: {
              click: function($event) {
                return _vm.toggleMenu()
              }
            }
          },
          [_c("v-icon", [_vm._v("mdi-menu")])],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _c("div", { staticStyle: { float: "left" } }, [
          _c(
            "a",
            {
              staticStyle: { "text-decoration": "underline" },
              attrs: { href: _vm.shopLink(), target: "_blank" }
            },
            [_vm._v("website content adjustment")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-box" },
          [
            _c(
              "v-avatar",
              { attrs: { size: "48", color: false ? "" : "primary" } },
              [
                false
                  ? _c("img", {
                      attrs: {
                        alt: "Avatar",
                        src:
                          "https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                      }
                    })
                  : _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v("mdi-account")
                    ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "ml-2",
                attrs: { icon: "", small: "", link: "" },
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [_c("v-icon", [_vm._v("mdi-logout")])],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-menu",
          {
            staticClass: "mobile-user",
            attrs: {
              bottom: "",
              "min-width": "200px",
              rounded: "",
              "offset-y": ""
            },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        {
                          staticClass: "mobile-user",
                          attrs: { icon: "", "x-large": "" }
                        },
                        on
                      ),
                      [
                        _c(
                          "v-avatar",
                          {
                            attrs: { size: "48", color: false ? "" : "primary" }
                          },
                          [
                            false
                              ? _c("img", {
                                  attrs: {
                                    alt: "Avatar",
                                    src:
                                      "https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                                  }
                                })
                              : _c("v-icon", { attrs: { color: "white" } }, [
                                  _vm._v("mdi-account")
                                ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          },
          [
            _vm._v(" "),
            _c(
              "v-card",
              [
                _c("v-list-item-content", { staticClass: "justify-center" }, [
                  _c(
                    "div",
                    { staticClass: "mx-auto text-center" },
                    [
                      _c(
                        "v-btn",
                        { attrs: { depressed: "", rounded: "", text: "" } },
                        [_vm._v(" Settings")]
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-3" }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            depressed: "",
                            rounded: "",
                            text: "",
                            link: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v(" Logout ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }